<template>
	<tr @click="$emit('click', $event)">
		<slot />
	</tr>
</template>

<script>
export default {
	name: 'HeaderRow',
};
</script>

<style scoped></style>
